import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/common'

/**
 * @description: 数据概况
 */
export function getDataOverview() {
  return axios.get(`${ApiUrl}/data_overview/`)
}

/**
 * @description: 项目销量统计
 */

export function getProjectData(params) {
  return axios.get(`${ApiUrl}/project_data/`, { params })
}

/**
 * @description: 渠道销量统计
 */
export function getSourceData(params) {
  return axios.get(`${ApiUrl}/source_data/`, { params })
}
